export function createPermissionObject(permission, types) {
    return { permission, types };
}
